import { PathOptions } from "leaflet";

export const estacoes_de_trem_do_grande_recife = (_feature: any): PathOptions => {
  return {
    color: "#F4A22D",
  };
};
